import OperatorNodeBase from "@/view/workflow/components/workflowGraph/node/OperatorNodeBase";
import {NodeProps} from "@xyflow/react";
import {GeneralNode} from "@/view/workflow/components/workflowGraph/types";


const GeneralOperatorNode = (props: NodeProps<GeneralNode>) => {
    return (
        <OperatorNodeBase {...props}/>
    )
}

export default GeneralOperatorNode;